// Scanner UX client-side: collisioni tra elementi interattivi + overflow orizzontale + punteggio UX Health.
let _lastEls = [];

export function scanUx() {
  const vw = window.innerWidth, vh = window.innerHeight;
  const sel = 'button, a[href], [role="button"], input, select, textarea, [data-testid]';
  const nodes = Array.from(document.querySelectorAll(sel)).filter((el) => {
    const r = el.getBoundingClientRect();
    const st = getComputedStyle(el);
    if (st.display === "none" || st.visibility === "hidden" || parseFloat(st.opacity) === 0) return false;
    if (r.width < 6 || r.height < 6) return false;
    if (r.bottom < 0 || r.top > vh) return false; // fuori dal fold verticale corrente
    return true;
  });
  const rects = nodes.map((el) => ({
    el,
    r: el.getBoundingClientRect(),
    label: (el.getAttribute("data-testid") || el.textContent || el.tagName || "").trim().slice(0, 40) || el.tagName,
  }));

  const collisions = [];
  const collEls = [];
  for (let i = 0; i < rects.length; i++) {
    for (let j = i + 1; j < rects.length; j++) {
      const a = rects[i], b = rects[j];
      if (a.el.contains(b.el) || b.el.contains(a.el)) continue;
      const ox = Math.max(0, Math.min(a.r.right, b.r.right) - Math.max(a.r.left, b.r.left));
      const oy = Math.max(0, Math.min(a.r.bottom, b.r.bottom) - Math.max(a.r.top, b.r.top));
      const area = ox * oy;
      if (area <= 4) continue;
      const minArea = Math.max(1, Math.min(a.r.width * a.r.height, b.r.width * b.r.height));
      const ratio = area / minArea;
      if (ratio > 0.15) {
        collisions.push({ a: a.label, b: b.label, ratio: +ratio.toFixed(2), overlap: Math.round(area) });
        collEls.push({ el: a.el, kind: "collision" }, { el: b.el, kind: "collision" });
      }
    }
  }

  const overflows = [];
  const ovEls = [];
  rects.forEach((x) => {
    if (x.r.left < -2 || x.r.right > vw + 2) {
      overflows.push({ label: x.label, left: Math.round(x.r.left), right: Math.round(x.r.right) });
      ovEls.push({ el: x.el, kind: "overflow" });
    }
  });

  _lastEls = [...collEls, ...ovEls];
  const score = Math.max(0, 100 - collisions.length * 6 - overflows.length * 4);
  return { collisions, overflows, score, viewport: `${vw}x${vh}`, route: window.location.pathname };
}

export function highlightCollisions() {
  _lastEls.forEach(({ el, kind }) => {
    if (!el || !el.style) return;
    const prevO = el.style.outline, prevOff = el.style.outlineOffset;
    el.style.outline = `2px solid ${kind === "overflow" ? "#FFB020" : "#F87171"}`;
    el.style.outlineOffset = "1px";
    setTimeout(() => { el.style.outline = prevO; el.style.outlineOffset = prevOff; }, 4500);
  });
}
